import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api/client";
import logger from "../utils/logger.js";

const LayoutContext = createContext();

/**
 * إصلاح الترميز من شكل "Ù…Ø¬Ù…ÙˆØ¹Ø© Ù…ÙˆØ³Ù‰"
 * إلى "مجموعة موسى"
 */
function fixEncoding(value) {
  if (typeof value !== "string") return value;

  if (!/[ÃÂÙØ]/.test(value)) {
    return value;
  }

  try {
    const bytes = new Uint8Array(
      Array.from(value, (ch) => ch.charCodeAt(0))
    );
    const decoded = new TextDecoder("utf-8").decode(bytes);
    return decoded;
  } catch (e) {
    logger.warn("fixEncoding failed, returning original value", e);
    return value;
  }
}

async function fetchSettings() {
  return await api.apiGet("settings");
}

export function LayoutProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loadingSettings, setLoadingSettings] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadSettings() {
      try {
        setLoadingSettings(true);

        const data = await fetchSettings();

        if (!cancelled && data?.status === "success" && data?.data) {
          const raw = data.data;

          const fixed = {};
          Object.keys(raw).forEach((key) => {
            fixed[key] = fixEncoding(raw[key]);
          });

          setSettings(fixed);
        }
      } catch (e) {
        logger.error("Error loading settings", e);
      } finally {
        if (!cancelled) {
          setLoadingSettings(false);
        }
      }
    }

    loadSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LayoutContext.Provider value={{ settings, loadingSettings }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  return useContext(LayoutContext);
}